import {Clear} from '@mui/icons-material'
import './icons-reverse.scss'


export const IconReverse =({icon}:{icon:React.ReactElement})=>{


    return (
        <div className="reverse-icon">
            <div className='icon-right'
            style={{direction:'rtl'}}>

              {icon}
            </div>
           <div className="x-line" >
     
            <Clear style={{color:'red'}} /> 
           </div>
        </div>
    )
}